import React from 'react';
import { StyledTimeLineCarousel } from './StyledTimeLineCarousel';
import PropTypes from "prop-types";
import CardCarousel from '../CardCarousel';
import { Swiper, SwiperSlide } from 'swiper/react';

const TimeLineCarousel = ({ arrayYears, handleHover, handleSwiper, handleChange}) => {

  return (
    <React.Fragment>
      {
        <StyledTimeLineCarousel
          onMouseMove={ () => {handleHover(true)}}
          onMouseEnter={ () => {handleHover(true)}}
          onMouseLeave={() => handleHover(false)}
        >
          
          <Swiper 
            slidesPerView={'auto'}
            spaceBetween={0}
            className="timeline--slider"
            onSwiper={(swiper) => handleSwiper(swiper)}
            onSlideChange={(swiper) => handleChange(swiper)}
            onReachEnd={(swiper) => swiper.snapGrid = [...swiper.slidesGrid]}
            
            >
            {
              arrayYears.map((key, i) => {
                return <SwiperSlide key={i}>
                          <CardCarousel key={i} image={key.image} title={key.title} text={key.text} />
                       </SwiperSlide>
              })
            }
          </Swiper>
          
        </StyledTimeLineCarousel>
          
      }
    </React.Fragment>
  );
};

TimeLineCarousel.propTypes = {
  active: PropTypes.number,
};

TimeLineCarousel.defaultProps = {
  tag: "div",
  active: 0
};

export default TimeLineCarousel;
